export default __webpack_public_path__ + "static/media/cat@2x.adb39699.png";